<template>
    <div >
        <div v-show="!input.hidden || input.hidden === false">
        <p  v-if="input.type === 'section'" class="title" style="margin-bottom:-20px">{{input.text}}</p>
        <p  v-if="input.type === 'space'" class="subheader" style="margin-top:10px">{{input.text}}</p>
        <v-select v-if="input.type === 'select'"
                  :items="input.items"
                  v-model="input.value"
                  :label="input.hint"
                  :rules="rules(input.value, input.rules)"
                  :required="required(input.rules)"
        ></v-select>
        <v-text-field v-else-if="input.type === 'text' || input.type === 'textarea'"
                      :label="input.hint"
                      v-model="input.value"
                      :suffix="input.suffix"
                      :textarea="input.type === 'textarea'"
                      :rules="rules(input.value, input.rules)"
                      :required="required(input.rules)"
        ></v-text-field>
        <date-input v-else-if="input.type === 'date'"
                    :label="input.hint"
                    v-model="input.value"
                    :rules="rules(input.value, input.rules)"
                    :required="required(input.rules)">
        </date-input>
        <multiple-select-input v-else-if="input.type === 'multiple-select'"
                   :label="input.hint"
                   v-model="input.value"
                   :items="input.items"
                   :rules="rules(input.value, input.rules)"
                   :required="required(input.rules)"
        ></multiple-select-input>
        <file-input
                v-else-if="input.type === 'file'"
                :label="input.hint"
                v-model="input.value"
                :rules="rules(input.value, input.rules)"
                :required="required(input.rules)"
                :max="input.max">
        </file-input>
        <div v-else-if="input.type === 'html'" v-html="input.value"></div>
        </div>
    </div>
</template>

<script>
    import DateInput from "./DateInput";
    import MultipleSelectInput from "./MultipleSelectInput";
    import FileInput from "./FileInput";

    export default {
        components: {
            FileInput,
            DateInput, MultipleSelectInput},
        name: "s-input",
        props: ['input', 'inputs'],
        data: () => ({ visible: true}),
        methods: {
            rules:  (v, rules) => {
                var r = [];
                if(rules) {
                    for (var i = 0; i < rules.length; i++) {
                        var rule = rules[i];
                        if (rule === 'required') r.push(v => !!v || 'Campo requerido');
                        else if (rule === 'email') r.push(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser válido');
                        else if (rule === 'date') r.push(/(\d{4})-(\d{2})-(\d{2})/.test(v) || 'Introduzca un día válido')
                    }
                }
                return r;
            },
            required: (rules) => {
                if(rules) {
                    for (var i = 0; i < rules.length; i++) {
                        if (rules[i] === 'required') return true
                    }
                }
                return false
            },
            condition(){
                this.input.hidden = true
                this.$watch(
                    function () {
                        var id = this.input.condition.input;
                        var input = this.inputs.filter(function (el) {
                            return el.id === id
                        })[0];
                        return input ? input.value : null;
                    },
                    function (value) {
                        var id = this.input.condition.input;
                        var input = this.inputs.filter(function (el) {
                            return el.id === id
                        })[0];
                        if (input.type==='date'){
                            for (var key in this.input.condition) {
                                if (this.input.condition.hasOwnProperty(key) && key !== 'input') {
                                    this.input.hidden = null;
                                    var date = new Date(this.input.condition[key].substr(1, this.input.condition[key].length-1))
                                    console.log(date)
                                    if(this.input.condition[key].charAt(0) === '>') {
                                       this.$set(this.input, key, new Date(value)>date)
                                    } else if (this.input.condition[key].charAt(0) === '<'){
                                        this.$set(this.input, key, new Date(value)<date)
                                    } else {
                                         this.input.hidden = true
                                    }
                                }
                            }
                        } else if (input.type==='select') {
                            for (var key in this.input.condition) {
                                if (this.input.condition.hasOwnProperty(key) && key !== 'input') {
                                    this.input.hidden = null;
                                    if (typeof this.input.condition[key][value] !== 'undefined') {
                                        this.$set(this.input, key, this.input.condition[key][value])
                                    } else if (typeof this.input.condition[key]['default'] !== 'undefined') {
                                        this.$set(this.input, key, this.input.condition[key]['default']);
                                    } else  this.input.hidden = true
                                    this.input.value = null
                                }
                            }
                        }
                    }
                );
            }
        },
        created() {
            if(this.input.condition)   this.condition()
        }
    }
</script>

<style scoped>
</style>